import Tooltip from './tooltip';

export default Tooltip;
export type * from './types';
